import React from "react";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

export default function AppLayout(props) {
  return (
    <>
      <main 
        style={{
          background: "#f6f7f9",
          height: "90%",
          width: "100%",
          position: "absolute",
          overflow: "scroll"
        }}
      >
        {props.children}
      </main>

      <nav 
        style={{
          position: "absolute",
          width: "100%",
          bottom: "0",
          background: "#fff",
        }}
      >
        <div className="row">
          <ul className="tabs tabs-fixed-width transparent" style={{lineHeight: "20px", textAlign: "center"}}>
            <li className="col s3">
              <NavLink style={{ color: "#a8a9ac", padding: "5px" }} activeClassName="app-active-item" to="/app/home">
                <span className="fa fa-home  fa-2x" style={{ display: "block", fontSize: "25px" }} ></span>
                <span style={{fontWeight: 500}}>Home</span>
              </NavLink>
            </li>
            <li className="col s3">
              <NavLink style={{ color: "#a8a9ac", padding: "5px" }} activeClassName="app-active-item" to="/app/qr">
                <span className="fa fa-qrcode  fa-2x" style={{ display: "block", fontSize: "25px" }} ></span>
                <span style={{fontWeight: 500}}>Scan</span>
              </NavLink>
            </li>
            <li className="col s3">
              <NavLink style={{ color: "#a8a9ac", padding: "5px" }} activeClassName="app-active-item" to="/app/history">
                <span className="fa fa-bookmark-o  fa-2x" style={{ display: "block", fontSize: "25px" }} ></span>
                <span style={{fontWeight: 500}}>History</span>
              </NavLink>
            </li>
            <li className="col s3">
              <NavLink style={{ color: "#a8a9ac", padding: "5px" }} activeClassName="app-active-item" to="/app/profile">
                <span className="fa fa-user-o  fa-2x" style={{ display: "block", fontSize: "25px" }} ></span>
                <span style={{fontWeight: 500}}>Profile</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}
